module.exports = __webpack_public_path__ + "img/L_323_328.64a781ae.png";